import React from 'react';

const PagerIcon = ({
    size = 24,
    color = 'currentColor',
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 256 256"
            fill="none"
            {...props}
        >
            {/* Outer device rectangle */}
            <rect
                x="32"
                y="48"
                width="192"
                height="160"
                rx="16"
                stroke={color}
                strokeWidth="16"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            {/* Screen/Display area */}
            <rect
                x="56"
                y="72"
                width="144"
                height="64"
                rx="4"
                stroke={color}
                strokeWidth="12"
                fill="none"
            />

            {/* Left triangle button */}
            <path
                d="M 88 172 L 64 184 L 88 196 Z"
                stroke={color}
                strokeWidth="12"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            {/* Right triangle button */}
            <path
                d="M 120 172 L 144 184 L 120 196 Z"
                stroke={color}
                strokeWidth="12"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            {/* Circle button */}
            <circle
                cx="184"
                cy="184"
                r="16"
                stroke={color}
                strokeWidth="12"
                fill="none"
            />
        </svg>
    );
};

export default PagerIcon;
